/*
 * Recently viewed products in the search drawer.
 *
 * Reads the same `recently-viewed` handle list the theme writes on product
 * pages and renders the cards through the existing
 * templates/search.recently-viewed.liquid view.
 *
 * Fetched lazily the first time the drawer opens, so visitors who never search
 * pay nothing for it.
 */
(function () {
  var STORAGE_KEY = 'recently-viewed';

  function storedHandles() {
    // private browsing and blocked site data both throw here
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw || raw === 'undefined') return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function currentHandle() {
    var el = document.querySelector('.thb-product-detail[data-handle]');
    return el ? el.dataset.handle : null;
  }

  function searchUrl() {
    if (window.theme && theme.routes && theme.routes.search_url) return theme.routes.search_url;
    return '/search';
  }

  function load(root) {
    if (root.dataset.loaded === 'true') return;
    root.dataset.loaded = 'true';

    var limit = parseInt(root.dataset.limit, 10) || 8;
    var skip = currentHandle();
    var handles = storedHandles()
      .filter(function (h) { return h && h !== skip; })
      .slice(0, limit);

    if (!handles.length) return;

    var query = handles
      .map(function (h) { return 'handle:' + h; })
      .join(' OR ');

    fetch(searchUrl() + '?view=recently-viewed&type=product&q=' + encodeURIComponent(query))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var source = holder.querySelector('.products');
        if (!source || !source.innerHTML.trim()) return;

        var list = root.querySelector('ul.products');
        if (!list) return;
        list.innerHTML = source.innerHTML;

        // the search view marks items .column; the slider sizes .columns
        Array.prototype.forEach.call(list.children, function (li) {
          li.classList.add('columns');
        });

        root.hidden = false;
      })
      .catch(function () {
        /* a failed fetch just leaves the block hidden */
      });
  }

  function loadAll() {
    document.querySelectorAll('.custom-search-recent').forEach(load);
  }

  function init() {
    var blocks = document.querySelectorAll('.custom-search-recent');
    if (!blocks.length) return;

    // load as soon as the drawer is opened
    document.querySelectorAll('.side-panel.search-drawer').forEach(function (panel) {
      new MutationObserver(function () {
        if (panel.classList.contains('active')) loadAll();
      }).observe(panel, { attributes: true, attributeFilter: ['class'] });
    });

    // and if the field is reached some other way (keyboard shortcut, deep link)
    document.addEventListener('focusin', function (e) {
      if (e.target.closest && e.target.closest('.search-drawer')) loadAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
